export default __webpack_public_path__ + "static/media/heart.2419babe.svg";